<template>
  <div class="news_details_wrap">
    <PCNavbar :selectIndex="4" />
    <MobileNavBar :currentActive="3" />
    <div class="news_content">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="news_bread">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <form name="_newscontent_fromname">
        <h1 class="h1tit">
          {{ details.title || '不存在此新闻' }}
        </h1>
        <h4 class="h4tit" v-if="details.title">
          作者：{{ details.author }}&nbsp;&nbsp;投稿时间：{{ formatDateToYMD(details.createTime) }}
        </h4>
        <div class="nr-div-p">
          <div v-html="details.content">
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/report_list/SpaNav.vue'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import { getNewsDetails } from '../../api/news';
import { formatDateToYMD } from '../../utils';

export default {
  mounted() {
    this.getNewsDetailsFunc()
  },
  data() {
    return {
      details: {}
    }
  },
  components: {
    PCNavbar,
    MobileNavBar,
  },
  methods: {
    async getNewsDetailsFunc() {
      const res = await getNewsDetails(this.$route.params.id)
      if (res.data) {
        this.details = res.data.data
      }
    },
    formatDateToYMD(dateStr) {
      return formatDateToYMD(dateStr)
    }
  },
  watch: {
    '$route'(to, from) {
      this.getNewsDetailsFunc();
    }
  }
}
</script>

<style lang="scss">
.news_content {
  width: 50%;
  margin: 0 auto;
  padding-top: 100px;

  @media screen and (max-width:768px) {
    width: 90%;
  }

  .news_bread {
    font-size: 14px;
    margin-bottom: 10px;

    @media screen and (max-width:768px) {
      font-size: 14px;
    }
  }
}

.nr-div-p {
  --nr-font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,
    "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Noto Sans CJK SC",
    "Noto Sans", sans-serif;
  --nr-font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;

  --nr-text: #1f2937;
  --nr-muted: #6b7280;
  --nr-link: #2563eb;
  --nr-link-hover: #1d4ed8;
  --nr-border: #e5e7eb;

  --nr-code-bg: #f6f8fa;
  --nr-quote-bg: #f9fafb;
  --nr-quote-bar: #93c5fd;

  --nr-radius: 8px;

  color: var(--nr-text);
  font-family: var(--nr-font-sans);
  font-size: 16px;
  line-height: 1.8;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* 文本在窄屏不溢出 */
  overflow-wrap: break-word;
  word-break: break-word;
}

/* 让首尾元素不额外留白 */
.nr-div-p> :first-child {
  margin-top: 0;
}

.nr-div-p> :last-child {
  margin-bottom: 0;
}

/* 标题层级与间距 */
.nr-div-p h1,
.nr-div-p h2,
.nr-div-p h3,
.nr-div-p h4,
.nr-div-p h5,
.nr-div-p h6 {
  line-height: 1.35;
  font-weight: 700;
  margin: 1.2em 0 0.6em;
}

.nr-div-p h1 {
  font-size: clamp(1.8rem, 1.2rem + 1.8vw, 2.2rem);
}

.nr-div-p h2 {
  font-size: clamp(1.6rem, 1.1rem + 1.4vw, 1.9rem);
}

.nr-div-p h3 {
  font-size: clamp(1.35rem, 1.05rem + 0.9vw, 1.6rem);
}

.nr-div-p h4 {
  font-size: 1.15rem;
}

.nr-div-p h5 {
  font-size: 1.05rem;
}

.nr-div-p h6 {
  font-size: 1rem;
  color: var(--nr-muted);
}

.nr-div-p p {
  margin: 0.8em 0;
}

/* 链接 */
.nr-div-p a {
  color: var(--nr-link);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.nr-div-p a:hover {
  color: var(--nr-link-hover);
}

/* 列表 */
.nr-div-p ul,
.nr-div-p ol {
  margin: 0.8em 0 0.8em 1.3em;
}

.nr-div-p li {
  margin: 0.3em 0;
}

.nr-div-p li>ul,
.nr-div-p li>ol {
  margin-top: 0.3em;
}

/* 图片与多媒体自适应 */
.nr-div-p img,
.nr-div-p video,
.nr-div-p canvas,
.nr-div-p svg {
  max-width: 100%;
  height: auto;
}

.nr-div-p img,
.nr-div-p video {
  display: block;
  margin: 1em auto;
  border-radius: 6px;
}

.nr-div-p iframe {
  max-width: 100%;
  width: 100%;
  border: 0;
}

/* figure */
.nr-div-p figure {
  margin: 1.2em 0;
}

.nr-div-p figcaption {
  margin-top: 0.5em;
  color: var(--nr-muted);
  font-size: 0.9em;
  text-align: center;
}

/* 引用 */
.nr-div-p blockquote {
  margin: 1em 0;
  padding: 0.8em 1em;
  background: var(--nr-quote-bg);
  border-left: 4px solid var(--nr-quote-bar);
  border-radius: 0 var(--nr-radius) var(--nr-radius) 0;
  color: inherit;
}

/* 代码 */
.nr-div-p code {
  font-family: var(--nr-font-mono);
  background: var(--nr-code-bg);
  border: 1px solid var(--nr-border);
  padding: 0.15em 0.35em;
  border-radius: 4px;
  font-size: 0.95em;
}

.nr-div-p pre {
  background: var(--nr-code-bg);
  border: 1px solid var(--nr-border);
  border-radius: var(--nr-radius);
  padding: 1em;
  overflow: auto;
  font-family: var(--nr-font-mono);
  font-size: 0.95em;
  line-height: 1.6;
  margin: 1em 0;
}

/* 去掉 pre 内 code 的重复底色与内边距 */
.nr-div-p pre code {
  background: transparent;
  border: 0;
  padding: 0;
}

/* 表格（可横向滚动） */
.nr-div-p table {
  display: block;
  /* 允许横向滚动容器 */
  width: max-content;
  max-width: 100%;
  overflow-x: auto;
  border: 1px solid var(--nr-border);
  border-radius: var(--nr-radius);
  margin: 1em 0;
  border-collapse: separate;
  border-spacing: 0;
}

.nr-div-p table th,
.nr-div-p table td {
  padding: 0.6em 0.8em;
  border-bottom: 1px solid var(--nr-border);
  white-space: nowrap;
  /* 保持单元格内容结构 */
}

.nr-div-p table thead th {
  background: #f3f4f6;
  font-weight: 600;
}

.nr-div-p table tr:last-child td {
  border-bottom: 0;
}

.nr-div-p table tbody tr:nth-child(even) {
  background: #fafafa;
}

/* 分割线 */
.nr-div-p hr {
  height: 1px;
  border: none;
  background: var(--nr-border);
  margin: 2em 0;
}

/* 其他内联元素 */
.nr-div-p strong,
.nr-div-p b {
  font-weight: 700;
}

.nr-div-p em,
.nr-div-p i {
  font-style: italic;
}

.nr-div-p mark {
  background: #fef08a;
  padding: 0.05em 0.25em;
  border-radius: 3px;
}

.nr-div-p kbd {
  font-family: var(--nr-font-mono);
  background: #111827;
  color: #fff;
  border-radius: 4px;
  padding: 0.1em 0.4em;
  font-size: 0.85em;
}

/* 详情/折叠 */
.nr-div-p details {
  background: rgba(148, 163, 184, 0.08);
  border: 1px solid var(--nr-border);
  border-radius: var(--nr-radius);
  padding: 0.6em 0.8em;
  margin: 1em 0;
}

.nr-div-p summary {
  cursor: pointer;
  font-weight: 600;
}

/* 选中效果 */
.nr-div-p ::selection {
  background: #c7d2fe;
}

/* 可选：文章阅读宽度（按需给容器再加类 nr-article） */
.nr-div-p.nr-article {
  max-width: 72ch;
  margin: 0 auto;
  padding: 1rem;
}

/* 暗色模式（跟随系统） */
@media (prefers-color-scheme: dark) {
  .nr-div-p {
    --nr-text: #e5e7eb;
    --nr-muted: #9ca3af;
    --nr-link: #93c5fd;
    --nr-link-hover: #bfdbfe;
    --nr-border: #374151;

    --nr-code-bg: #111827;
    --nr-quote-bg: #0b1220;
    --nr-quote-bar: #3b82f6;
  }

  .nr-div-p table thead th {
    background: #0f172a;
  }

  .nr-div-p table tbody tr:nth-child(even) {
    background: #0b1220;
  }
}

.nr-div-p p {
  text-align: left;
  font-size: 14PX;
  line-height: 30PX;
  font-weight: normal;
  color: #000;

  @media screen and (max-width:768px) {
    line-height: 24px;
    font-size: 14px;
    text-indent: 2em;
    padding: 10px 0;
  }
}

.clear {
  clear: both;
}

.img_vsb_content {
  width: 70%;
}

.h1tit {
  @media screen and (max-width:768px) {
    font-size: 20px;
  }
}

.h4tit {
  @media screen and (max-width:768px) {
    font-size: 14px;
  }
}

.v_news_content {
  text-align: center;

  img {
    @media screen and (max-width:768px) {
      width: 90%;
    }
  }
}
</style>